export const formatCurrency = (amount, currency = 'USD', locale = 'en-US') => {
  const numericAmount = Number(amount);

  if (isNaN(numericAmount)) return ''; // Handle invalid input gracefully

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(numericAmount);
  };